import { axiosInstance } from "../../Authentication/AxiosInterceptor";
import { IDrawerSection } from "../../Types/Drawer/ISectionsDrawerItem";
import { CreateChatResponse } from "../../Types/Analyse/CreateChatResponse";
import { AnalyseLinkedEvidenceFile } from "../../Types/Analyse/AnalyseChatData";

export async function UpdateChatPrompt(chatId: string, promptId: string) {

    try {

      await axiosInstance.patch(`UpdateChatPrompt/${chatId}/${promptId}`);
       
      } catch (error) {
        console.log(error);
        throw error;
      }
  }

  export async function UpdateChatActivities(chatId: string, activityIds: string[]) {

    try {
        
      await axiosInstance.patch(`UpdateChatActivities/${chatId}`, activityIds);
       
      } catch (error) {
        console.log(error);
        throw error;
      }
  }

export async function CreateChat(userSub: string, clientId: string, chatName: string) {

    try {
        
    var response = await axiosInstance.get(`CreateChatByUserSubAndClientId/${userSub}/${clientId}`);
    
    var section = response.data as CreateChatResponse;

    return section;
        
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function DeleteChat(chatId: string) {

    try {
        
    var response = await axiosInstance.get(`DeleteChat/${chatId}`);
        
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function DeleteMyAnalyseChats(clientId: string) {
    await axiosInstance.post(`DeleteMyAnalyseChats/${clientId}`);
}

export async function ArchiveMyAnalyseChats(clientId: string) {
    await axiosInstance.post(`ArchiveMyAnalyseChats/${clientId}`);
}

export async function ArchiveChat(chatId: string) {

    try {
        
    var response = await axiosInstance.get(`ArchiveChat/${chatId}`);
        
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function UpdateChatTitle(chatId: string, chatTitle: string) {
  await axiosInstance.get(
    `UpdateChatTitle/${chatId}/${encodeURIComponent(chatTitle)}`
  );
}

export async function GetAnalyseChatSummary(chatId: string): Promise<{
  id: string;
  title: string;
  chatSummary: string;
}> {
  const response = await axiosInstance.get(`GetAnalyseChatSummary/${chatId}`);
  return response.data;
}

export async function GetEmptyChat(clientId: string) {

    try {
        
    var response = await axiosInstance.get(`GetEmptyChat/${clientId}`);
    return response.data as string;
        
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function GetArchivedChats(clientId: string, userSub: string) {

    try {
        
    var response = await axiosInstance.get(`GetArchivedChats/${clientId}/${userSub}`);
    return response.data as IDrawerSection[];
        
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function UnarchiveChat(chatId: string) {

    try {
        
    var response = await axiosInstance.get(`UnarchiveChat/${chatId}`);
        
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function getAnalyseLinkedEvidence(chatId: string): Promise<AnalyseLinkedEvidenceFile[]> {
  const response = await axiosInstance.get<AnalyseLinkedEvidenceFile[]>(`AnalyseLinkedEvidence/${chatId}`);
  return Array.isArray(response.data) ? response.data : [];
}

export async function deleteAnalyseFileLink(chatId: string, linkId: string): Promise<void> {
  await axiosInstance.delete(`AnalyseFileLink/${chatId}/${linkId}`);
}

export type ChatSearchRelevance = 'high' | 'medium' | 'low';

export type ChatSearchResult = {
  contextId: string;
  relevance: ChatSearchRelevance;
  rank: number;
  /** Verbatim phrases the ranking model used (from title/summary/snippets). */
  matchedTexts: string[];
};

export type ChatSearchResponse = {
  results: ChatSearchResult[];
};

export async function searchAnalyseChats(
  clientId: string,
  query: string,
  signal?: AbortSignal
): Promise<ChatSearchResponse> {
  const response = await axiosInstance.post<ChatSearchResponse>(
    "SearchAnalyseChats",
    { clientId, query },
    { signal }
  );
  const results = Array.isArray(response.data?.results) ? response.data.results : [];
  return { results };
}

